// Todo: This should be coming from the API
export const AVAILABLE_PUBLIC_LOCATIONS = ['West Europe', 'Central US'];
export const AVAILABLE_INTERNAL_LOCATIONS = ['Internal - APMoller.Net'];
